var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14935 4.47427C3.33156 4.17945 3.65342 4 4 4H28C28.3466 4 28.6684 4.17945 28.8507 4.47427C29.0329 4.76909 29.0494 5.13723 28.8944 5.44721L16.8944 29.4472C16.725 29.786 16.3788 30 16 30C15.6212 30 15.275 29.786 15.1056 29.4472L3.10557 5.44721C2.95058 5.13723 2.96714 4.76909 3.14935 4.47427ZM5.61804 6L9.36752 13.499L25.2464 8.27105L26.382 6H5.61804ZM23.9862 10.7916L10.2715 15.307L12.7471 20.2581L20.6818 17.4004L23.9862 10.7916ZM19.3855 19.993L13.6478 22.0595L16 26.7639L19.3855 19.993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.f364bff1ae99cf2388cc001fb1ca12af.svg";
export { ForwardRef as ReactComponent };